(function () {

    'use strict';

    angular
        .module('app.search')
        .factory('SearchService', [
            '$q',
            'OpenlaneService',
            'ApiService',
            SearchService
        ]);

    function SearchService($q, openlaneService, apiService) {

        var service = {
            getSearchContext: getSearchContext,
            search: search,
            searchResultOptions: searchResultOptions,
            winnowingValues: winnowingValues
        };

        return service;

        function executeInScope(_scope, action) {
            if (_scope.$$phase) action();
            else _scope.$apply(action);
        }

        function getSearchContext(_scope) {
            var deferred = $q.defer();
            if (_scope.searchContext) {
                executeInScope(_scope, function () {
                    deferred.resolve(_scope.searchContext)
                });
            }
            else {
                openlaneService.search31APISearchContextDeferred.promise.then(function (searchContext) {
                    _scope.searchContext = searchContext;
                    executeInScope(_scope, function () {
                        deferred.resolve(searchContext)
                    });
                },function(err){
                        deferred.reject("Error connection")
                });
            }
            return deferred.promise;
        }

        function search(_scope, searchContextHandler) {
            var deferred = $q.defer();
            service.getSearchContext(_scope).then(function (searchContext) {
                searchContext = searchContext.getSearchContextFactory().createSearchContext();
                searchContextHandler(searchContext);
                searchContext.search(function (status, searchResult) {
                    executeInScope(_scope, function () {
                        deferred.resolve(searchResult)
                    });
                });
            });
            return deferred.promise;
        }

        function searchResultOptions() {
        	return apiService.getSearchResultOptions();
        }

        function winnowingValues() {
            return apiService.getWinnowingValues();
        }

    }

})();



// WEBPACK FOOTER //
// ./app/search/components/service/SearchService.js